(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tu-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tu-reveal]').forEach((el) => {
    if (!('IntersectionObserver' in window)) { el.classList.add('is-inview'); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { el.classList.add('is-inview'); io.disconnect(); }
      });
    }, { threshold: 0.25 });
    io.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tu-brands"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tu-brands').forEach((section) => {
  const track = section.querySelector('[data-tu-track]');
  if (!track) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const items = [...track.children];
  const fallback = () => {
    section.querySelectorAll('[data-tu-scroll]').forEach((btn) => btn.addEventListener('click', () => track.scrollBy({ left: Number(btn.dataset.tuScroll) * track.clientWidth * 0.8, behavior: 'smooth' })));
  };
  if (reduce || items.length < 4) { fallback(); return; }
  const rail = document.createElement('div');
  rail.className = 'tu-brands__rail';
  rail.style.gap = getComputedStyle(track).gap;
  items.forEach((el) => rail.appendChild(el));
  items.forEach((el) => { const clone = el.cloneNode(true); clone.setAttribute('aria-hidden', 'true'); clone.tabIndex = -1; rail.appendChild(clone); });
  track.appendChild(rail);
  track.classList.add('is-auto');
  let loopWidth = 0, pos = 0, paused = false, hover = false, visible = true, idleTimer = null, last = 0, tween = null;
  const speed = 28;
  const measure = () => { const gap = parseFloat(getComputedStyle(rail).gap) || 0; loopWidth = (rail.scrollWidth + gap) / 2; };
  const render = () => { if (loopWidth) { pos = ((pos % loopWidth) + loopWidth) % loopWidth; } rail.style.transform = 'translate3d(' + (-pos).toFixed(2) + 'px,0,0)'; };
  const userPause = (ms) => { paused = true; clearTimeout(idleTimer); idleTimer = setTimeout(() => { paused = false; }, ms || 4000); };
  const step = (ts) => {
    if (last) {
      const dt = Math.min(50, ts - last);
      if (tween) { const k = Math.min(1, (ts - tween.t0) / tween.dur); const e = 1 - Math.pow(1 - k, 3); pos = tween.from + (tween.to - tween.from) * e; if (k >= 1) tween = null; render(); }
      else if (!paused && !hover && visible && !document.hidden) { pos += speed * dt / 1000; render(); }
    }
    last = ts; requestAnimationFrame(step);
  };
  section.querySelectorAll('[data-tu-scroll]').forEach((btn) => {
    btn.addEventListener('click', () => { userPause(5000); tween = { from: pos, to: pos + Number(btn.dataset.tuScroll) * track.clientWidth * 0.6, t0: performance.now(), dur: 500 }; });
  });
  let drag = null, movedAt = 0;
  track.addEventListener('pointerdown', (e) => { drag = { x: e.clientX, start: pos, moved: false }; userPause(5000); });
  window.addEventListener('pointermove', (e) => { if (!drag) return; const dx = e.clientX - drag.x; if (Math.abs(dx) > 4) drag.moved = true; pos = drag.start - dx; tween = null; render(); });
  window.addEventListener('pointerup', () => { if (drag && drag.moved) movedAt = Date.now(); drag = null; });
  track.addEventListener('click', (e) => { if (Date.now() - movedAt < 400) { e.preventDefault(); e.stopPropagation(); } }, true);
  track.addEventListener('dragstart', (e) => e.preventDefault());
  track.addEventListener('wheel', (e) => { const d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : 0; if (!d) return; e.preventDefault(); userPause(4000); pos += d; tween = null; render(); }, { passive: false });
  track.addEventListener('mouseenter', () => { hover = true; });
  track.addEventListener('mouseleave', () => { hover = false; });
  if ('IntersectionObserver' in window) new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; }).observe(track);
  window.addEventListener('resize', measure);
  const start = () => { measure(); render(); requestAnimationFrame(step); };
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tu-category-carousel"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tu-catc').forEach((section) => {
  const track = section.querySelector('[data-tu-track]');
  if (!track) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const items = [...track.children];
  const fallback = () => {
    section.querySelectorAll('[data-tu-scroll]').forEach((btn) => btn.addEventListener('click', () => track.scrollBy({ left: Number(btn.dataset.tuScroll) * track.clientWidth * 0.8, behavior: 'smooth' })));
  };
  if (reduce || items.length < 4) { fallback(); return; }
  // Rail aufbauen: Items + Klone in einen transformierten Container
  const rail = document.createElement('div');
  rail.className = 'tu-catc__rail';
  rail.style.gap = getComputedStyle(track).gap;
  items.forEach((el) => rail.appendChild(el));
  items.forEach((el) => { const clone = el.cloneNode(true); clone.setAttribute('aria-hidden', 'true'); clone.tabIndex = -1; rail.appendChild(clone); });
  track.appendChild(rail);
  track.classList.add('is-auto');
  let loopWidth = 0, pos = 0, paused = false, hover = false, visible = true, idleTimer = null, last = 0, tween = null;
  const speed = 22;
  const measure = () => { const gap = parseFloat(getComputedStyle(rail).gap) || 0; loopWidth = (rail.scrollWidth + gap) / 2; };
  const render = () => { if (loopWidth) { pos = ((pos % loopWidth) + loopWidth) % loopWidth; } rail.style.transform = 'translate3d(' + (-pos).toFixed(2) + 'px,0,0)'; };
  const userPause = (ms) => { paused = true; clearTimeout(idleTimer); idleTimer = setTimeout(() => { paused = false; }, ms || 4000); };
  const step = (ts) => {
    if (last) {
      const dt = Math.min(50, ts - last);
      if (tween) { const k = Math.min(1, (ts - tween.t0) / tween.dur); const e = 1 - Math.pow(1 - k, 3); pos = tween.from + (tween.to - tween.from) * e; if (k >= 1) tween = null; render(); }
      else if (!paused && !hover && visible && !document.hidden) { pos += speed * dt / 1000; render(); }
    }
    last = ts; requestAnimationFrame(step);
  };
  section.querySelectorAll('[data-tu-scroll]').forEach((btn) => {
    btn.addEventListener('click', () => { userPause(5000); tween = { from: pos, to: pos + Number(btn.dataset.tuScroll) * track.clientWidth * 0.8, t0: performance.now(), dur: 500 }; });
  });
  // Wischen / Ziehen
  let drag = null;
  track.addEventListener('pointerdown', (e) => { drag = { x: e.clientX, start: pos, moved: false }; userPause(5000); });
  window.addEventListener('pointermove', (e) => { if (!drag) return; const dx = e.clientX - drag.x; if (Math.abs(dx) > 4) drag.moved = true; pos = drag.start - dx; tween = null; render(); });
  let movedAt = 0;
  window.addEventListener('pointerup', () => { if (drag && drag.moved) movedAt = Date.now(); drag = null; });
  track.addEventListener('click', (e) => { if (Date.now() - movedAt < 400) { e.preventDefault(); e.stopPropagation(); } }, true);
  track.addEventListener('dragstart', (e) => e.preventDefault());
  track.addEventListener('wheel', (e) => { const d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : 0; if (!d) return; e.preventDefault(); userPause(4000); pos += d; tween = null; render(); }, { passive: false });
  track.addEventListener('mouseenter', () => { hover = true; });
  track.addEventListener('mouseleave', () => { hover = false; });
  if ('IntersectionObserver' in window) new IntersectionObserver((entries) => { visible = entries[0].isIntersecting; }).observe(track);
  window.addEventListener('resize', measure);
  const start = () => { measure(); render(); requestAnimationFrame(step); };
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tu-collection-cards"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tu-cc').forEach((section) => {
  const track = section.querySelector('[data-tu-cc-track]');
  if (!track) return;
  section.querySelectorAll('[data-tu-cc]').forEach((btn) => btn.addEventListener('click', () => {
    const card = track.querySelector('.tu-cc__card');
    const step = card ? card.getBoundingClientRect().width + 10 : track.clientWidth * 0.8;
    track.scrollBy({ left: Number(btn.dataset.tuCc) * step, behavior: 'smooth' });
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tu-header"]) return;
  try {
    
  (() => {
    const header = document.getElementById('tu-header');
    if (!header) return;
    const burger = header.querySelector('[data-tu-burger]');
    const nav = header.querySelector('[data-tu-nav]');
    const toggle = header.querySelector('[data-tu-search-toggle]');
    const mobileSearch = header.querySelector('[data-tu-mobile-search]');
    const vehicleLabel = header.querySelector('[data-tu-vehicle-label]');
    const group = header.closest('.page-wrapper > *') || header;
    const scroller = header.closest('.page-wrapper');
    const topBar = document.querySelector('.tu-top');
    const setTopH = () => group.style.setProperty('--tu-top-h', (topBar ? topBar.offsetHeight : 0) + 'px');
    setTopH();
    window.addEventListener('resize', setTopH);
    const getY = () => (scroller ? scroller.scrollTop : window.scrollY);
    let lastY = getY();
    let ticking = false;
    let holdUntil = 0;
    const onScroll = () => {
      const y = getY();
      const navOpen = nav && nav.classList.contains('is-open');
      if (!navOpen) {
        if (y > lastY && y > 160 && Date.now() > holdUntil) {
          group.classList.add('is-hidden');
          header.querySelectorAll('.tu-header__details[open]').forEach((d) => d.removeAttribute('open'));
        } else if (y < lastY - 2 || y <= 0) {
          group.classList.remove('is-hidden');
        }
      }
      header.classList.toggle('is-stuck', y > 40);
      lastY = y;
      ticking = false;
    };
    (scroller || window).addEventListener('scroll', () => {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
    document.addEventListener('tu:cart', () => {
      holdUntil = Date.now() + 3000;
      group.classList.remove('is-hidden');
      lastY = getY();
    });
    burger?.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    });
    toggle?.addEventListener('click', () => {
      mobileSearch.hidden = !mobileSearch.hidden;
      if (!mobileSearch.hidden) mobileSearch.querySelector('input')?.focus();
    });
    document.addEventListener('click', (event) => {
      header.querySelectorAll('.tu-header__details[open]').forEach((d) => {
        if (!d.contains(event.target)) d.removeAttribute('open');
      });
    });
    try {
      const stored = JSON.parse(localStorage.getItem('tu_vehicle') || 'null');
      if (stored && stored.label && vehicleLabel) vehicleLabel.textContent = stored.label.split(' · ')[0];
    } catch (error) {
      console.warn(error);
    }
  })();
  (() => {
    const cartEl = document.querySelector('[data-tu-cart]');
    if (!cartEl || window.__tuCartLive) return;
    window.__tuCartLive = true;
    const totalEl = cartEl.querySelector('[data-tu-cart-total]');
    const badgeEl = cartEl.querySelector('[data-tu-cart-badge]');
    const format = cartEl.dataset.moneyFormat || '';
    let prevCount = badgeEl ? (parseInt(badgeEl.textContent, 10) || 0) : 0;
    let lastSource = null;
    document.addEventListener('click', (event) => {
      const btn = event.target.closest('button, [type="submit"]');
      if (!btn) return;
      const scope = btn.closest('form[action*="/cart/add"], .quick-add, product-form-component, .tu-pc__form, quick-add-component');
      if (!scope) return;
      const holder = btn.closest('product-card, .tu-pc__card, product-information, .product-information, [id$="__main"]') || document;
      const img = holder.querySelector('.card-gallery img, .tu-pc__media img, .product-media-container img, img');
      lastSource = img || null;
    }, true);
    const pop = () => { cartEl.classList.remove('is-pop'); void cartEl.offsetWidth; cartEl.classList.add('is-pop'); };
    const celebrate = () => {
      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      setTimeout(() => {
        const target = cartEl.getBoundingClientRect();
        const src = lastSource && lastSource.isConnected ? lastSource : null;
        if (!reduce && src && src.currentSrc && target.width) {
          const r = src.getBoundingClientRect();
          if (r.width > 10 && r.height > 10 && r.bottom > 0 && r.top < window.innerHeight) {
            const fly = document.createElement('img');
            fly.src = src.currentSrc;
            fly.alt = '';
            fly.className = 'tu-fly';
            fly.style.left = r.left + 'px';
            fly.style.top = r.top + 'px';
            fly.style.width = r.width + 'px';
            fly.style.height = r.height + 'px';
            document.body.appendChild(fly);
            const dx = target.left + target.width / 2 - (r.left + r.width / 2);
            const dy = target.top + target.height / 2 - (r.top + r.height / 2);
            requestAnimationFrame(() => requestAnimationFrame(() => {
              fly.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.12)';
              fly.style.opacity = '0.15';
              fly.style.borderRadius = '999px';
            }));
            setTimeout(() => { fly.remove(); pop(); }, 720);
            return;
          }
        }
        pop();
      }, 380);
    };
    const group = (str, sep) => str.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    const money = (cents) => {
      const n = cents / 100;
      const [int, dec] = n.toFixed(2).split('.');
      const whole = Math.round(n).toString();
      if (!format) return 'CHF ' + group(int, ',') + '.' + dec;
      return format
        .replace(/\{\{\s*amount\s*\}\}/g, group(int, ',') + '.' + dec)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(whole, ','))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, group(int, '.') + ',' + dec)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, group(whole, '.'))
        .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, group(int, "'") + '.' + dec)
        .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, group(int, ' ') + ',' + dec);
    };
    const render = (cart) => {
      if (!cart || typeof cart.item_count !== 'number') return;
      if (totalEl) totalEl.textContent = money(cart.total_price);
      if (badgeEl) {
        const prev = badgeEl.textContent;
        badgeEl.textContent = cart.item_count;
        badgeEl.hidden = cart.item_count === 0;
        if (String(cart.item_count) !== prev && cart.item_count > 0) {
          badgeEl.classList.remove('is-bump');
          void badgeEl.offsetWidth;
          badgeEl.classList.add('is-bump');
        }
      }
      if (cart.item_count > prevCount) celebrate();
      prevCount = cart.item_count;
      document.dispatchEvent(new CustomEvent('tu:cart', { detail: cart }));
    };
    let timer = null;
    const refresh = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then((r) => (r.ok ? r.json() : null))
          .then(render)
          .catch(() => {});
      }, 120);
    };
    window.tuCartRefresh = refresh;
    const isCartMutation = (url) => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
    const origFetch = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const p = origFetch.apply(this, arguments);
      if (isCartMutation(url)) p.then(() => refresh(), () => {});
      return p;
    };
    const origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (typeof url === 'string' && isCartMutation(url)) this.addEventListener('loadend', refresh);
      return origOpen.apply(this, arguments);
    };
    ['cart:update', 'cart:updated', 'cart-update', 'cart:refresh', 'cart:change'].forEach((name) => document.addEventListener(name, refresh));
    window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
  })();
  (() => {
    const esc = (v) => String(v || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
    let indexPromise = null;
    window.tuSearchIndex = () => {
      if (indexPromise) return indexPromise;
      indexPromise = (async () => {
        try {
          const all = [];
          for (let page = 1; page <= 8; page += 1) {
            const r = await fetch('/products.json?limit=250&page=' + page, { headers: { Accept: 'application/json' } });
            if (!r.ok) break;
            const j = await r.json();
            const list = (j && j.products) || [];
            all.push(...list);
            if (list.length < 250) break;
          }
          return all.map((p) => {
            const tags = Array.isArray(p.tags) ? p.tags.join(' ') : String(p.tags || '');
            const variants = p.variants || [];
            const skus = variants.map((v) => v.sku || '').join(' ');
            const titleLower = String(p.title || '').toLowerCase();
            return {
              title: p.title,
              url: '/products/' + p.handle,
              vendor: p.vendor || '',
              type: p.product_type || '',
              price: variants[0] ? variants[0].price : '',
              featured_image: { url: p.images && p.images[0] ? p.images[0].src : '' },
              titleLower,
              titleWords: titleLower.split(/[^a-z0-9äöüéèàß]+/i).filter(Boolean),
              hay: (titleLower + ' ' + (p.vendor || '') + ' ' + (p.product_type || '') + ' ' + tags + ' ' + skus).toLowerCase()
            };
          });
        } catch (error) {
          return null;
        }
      })();
      return indexPromise;
    };
    document.querySelectorAll('[data-tu-search-form]').forEach((form) => {
      const input = form.querySelector('.tu-search__input');
      const box = form.querySelector('[data-tu-suggest]');
      if (!input || !box) return;
      
      const suggestUrl = form.dataset.suggestUrl || '/search/suggest';
      const searchUrl = form.dataset.searchUrl || '/search';
      let timer = null;
      let controller = null;
      let active = -1;
      const close = () => { box.hidden = true; box.innerHTML = ''; active = -1; };
      const allLink = (q) => '<a class="tu-suggest__all" href="' + searchUrl + '?q=' + encodeURIComponent(q) + '&type=product">Alle Ergebnisse für „' + esc(q) + '“ anzeigen</a>';
      const render = (products, q) => {
        if (!products.length) {
          box.innerHTML = '<p class="tu-suggest__empty">Keine Produkte für „' + esc(q) + '“ gefunden.</p>' + allLink(q);
        } else {
          box.innerHTML = products.map((p) => {
            const img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.includes('?') ? '&' : '?') + 'width=120' : '';
            const price = p.price ? 'CHF ' + String(p.price).replace(/\B(?=(\d{3})+(?!\d))/g, "'") : '';
            const meta = [p.vendor, p.type].filter(Boolean).join(' · ');
            return '<a class="tu-suggest__item" href="' + esc(p.url) + '">' +
              '<span class="tu-suggest__thumb">' + (img ? '<img src="' + esc(img) + '" alt="" width="52" height="52">' : '') + '</span>' +
              '<span class="tu-suggest__body"><span class="tu-suggest__title">' + esc(p.title) + '</span>' + (meta ? '<span class="tu-suggest__meta">' + esc(meta) + '</span>' : '') + '</span>' +
              '<span class="tu-suggest__price">' + esc(price) + '</span></a>';
          }).join('') + allLink(q);
        }
        box.hidden = false;
        active = -1;
      };
      input.addEventListener('input', () => {
        const q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { close(); return; }
        timer = setTimeout(async () => {
          if (controller) controller.abort();
          controller = new AbortController();
          try {
            // zuerst die Shopify-Suche (kennt alle Produkte), lokaler Index nur als Rückfall
            const params = 'q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,tag';
            let products = [];
            try {
              const r = await fetch(suggestUrl + '.json?' + params, { signal: controller.signal, headers: { Accept: 'application/json' } });
              if (r.ok) {
                const data = await r.json();
                products = (data.resources && data.resources.results && data.resources.results.products) || [];
              }
            } catch (error) {
              if (error.name === 'AbortError') return;
            }
            if (!products.length) {
              const local = await window.tuSearchIndex();
              if (local && local.length) {
                const terms = q.toLowerCase().split(/\s+/).filter(Boolean);
              const scored = local.map((p) => {
                let score = 0;
                for (const t of terms) {
                  if (p.titleLower.startsWith(t)) score += 6;
                  else if (p.titleWords.some((w) => w.startsWith(t))) score += 4;
                  else if (p.hay.includes(t)) score += 1;
                  else return null;
                }
                return { p, score };
              }).filter(Boolean).sort((a, b) => b.score - a.score).slice(0, 6).map((x) => x.p);
                products = scored;
              }
            }
            render(products, q);
          } catch (error) {
            if (error.name !== 'AbortError') close();
          }
        }, 160);
      });
      input.addEventListener('focus', () => { if (box.innerHTML && input.value.trim().length >= 2) box.hidden = false; });
      input.addEventListener('keydown', (event) => {
        const items = [...box.querySelectorAll('.tu-suggest__item, .tu-suggest__all')];
        if (event.key === 'Escape') { close(); return; }
        if (box.hidden || !items.length) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          active = event.key === 'ArrowDown' ? Math.min(active + 1, items.length - 1) : Math.max(active - 1, 0);
          items.forEach((el, i) => el.classList.toggle('is-active', i === active));
          items[active].scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter' && active >= 0) {
          event.preventDefault();
          window.location.href = items[active].getAttribute('href');
        }
      });
      document.addEventListener('click', (event) => { if (!form.contains(event.target)) close(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tu-hero-car"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.tu-hc');
    if (!root) return;
    const scrollBtn = root.querySelector('[data-tu-scroll-down]');
    if (scrollBtn) {
      scrollBtn.addEventListener('click', () => {
        const header = document.getElementById('tu-header');
        const offset = header ? header.offsetHeight : 0;
        window.scrollTo({ top: root.getBoundingClientRect().bottom + window.scrollY - offset, behavior: 'smooth' });
      });
    }
    const form = root.querySelector('.tu-hc__form');
    const selects = [...root.querySelectorAll('.tu-hc__select')];
    const submit = root.querySelector('.tu-hc__submit');
    const saved = root.querySelector('.tu-hc__saved');
    const savedValue = root.querySelector('.tu-hc__saved-value');
    const reset = root.querySelector('.tu-hc__reset');
    const KEY = 'tu_vehicle';
    let data = [];

    const fill = (select, items, placeholder) => {
      select.innerHTML = '';
      const first = document.createElement('option');
      first.value = '';
      first.textContent = placeholder;
      select.appendChild(first);
      items.forEach((item) => {
        const option = document.createElement('option');
        option.value = String(item[0]);
        option.textContent = item[1];
        select.appendChild(option);
      });
      select.disabled = items.length === 0;
    };

    const placeholders = selects.map((s) => s.options[0].textContent);

    const brandOf = (id) => data.find((b) => String(b[0]) === String(id));
    const modelOf = (brand, id) => (brand ? brand[2].find((m) => String(m[0]) === String(id)) : null);

    const update = () => {
      const brand = brandOf(selects[0].value);
      const model = modelOf(brand, selects[1].value);
      submit.disabled = !(brand && model && selects[2].value);
    };

    selects[0].addEventListener('change', () => {
      const brand = brandOf(selects[0].value);
      fill(selects[1], brand ? brand[2].map((m) => [m[0], m[1]]) : [], placeholders[1]);
      fill(selects[2], [], placeholders[2]);
      update();
    });
    selects[1].addEventListener('change', () => {
      const brand = brandOf(selects[0].value);
      const model = modelOf(brand, selects[1].value);
      fill(selects[2], model ? model[2] : [], placeholders[2]);
      update();
    });
    selects[2].addEventListener('change', update);

    const showSaved = (label) => {
      if (!label) {
        saved.hidden = true;
        return;
      }
      savedValue.textContent = label;
      saved.hidden = false;
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const brand = brandOf(selects[0].value);
      const model = modelOf(brand, selects[1].value);
      const engine = model ? model[2].find((e) => String(e[0]) === selects[2].value) : null;
      if (!brand || !model || !engine) return;
      const label = `${brand[1]} ${model[1]} · ${engine[1]}`;
      try {
        localStorage.setItem(KEY, JSON.stringify({ id: engine[0], brand: brand[0], model: model[0], gidE: engine[2] || '', gidM: model[3] || '', gidB: brand[3] || '', gidC: engine[3] || [], label }));
      } catch (error) {
        console.warn(error);
      }
      const params = new URLSearchParams();
      [engine[2], model[3], brand[3]].concat(engine[3] || []).filter(Boolean).forEach((g) => params.append('filter.p.m.custom.fahrzeuge', `gid://shopify/Metaobject/${g}`));
      location.href = `${root.dataset.target || '/collections/all'}?${params.toString()}`;
    });

    reset.addEventListener('click', () => {
      try {
        localStorage.removeItem(KEY);
      } catch (error) {
        console.warn(error);
      }
      showSaved('');
    });

    try {
      const stored = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (stored && stored.label) showSaved(stored.label);
    } catch (error) {
      console.warn(error);
    }

    fetch(root.dataset.vehicleSrc)
      .then((response) => response.json())
      .then((json) => {
        data = Array.isArray(json) ? json : [];
        fill(selects[0], data.map((b) => [b[0], b[1]]), placeholders[0]);
      })
      .catch((error) => console.warn('[tu-hero-car] Fahrzeugdaten konnten nicht geladen werden', error));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tu-product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tu-pc').forEach((section) => {
    const track = section.querySelector('[data-tu-track]');
    section.querySelectorAll('[data-tu-scroll]').forEach((btn) => {
      btn.addEventListener('click', () => {
        track.scrollBy({ left: Number(btn.dataset.tuScroll) * track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
    section.querySelectorAll('form.tu-pc__form').forEach((form) => {
      form.addEventListener('submit', (event) => {
        if (!window.fetch) return;
        event.preventDefault();
        const button = form.querySelector('.tu-pc__cart');
        if (!button || button.classList.contains('is-busy')) return;
        button.classList.add('is-busy');
        button.disabled = true;
        const body = new FormData(form);
        fetch(form.getAttribute('action') + '.js', { method: 'POST', body, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
          .then((r) => r.json().then((data) => ({ ok: r.ok, data })))
          .then(({ ok, data }) => {
            if (!ok) throw new Error((data && data.description) || 'Fehler');
            button.classList.add('is-done');
            section.dispatchEvent(new CustomEvent('tu:added', { bubbles: true, detail: data }));
            let toast = document.querySelector('[data-tu-toast]');
            if (!toast) {
              toast = document.createElement('div');
              toast.className = 'tu-toast';
              toast.setAttribute('data-tu-toast', '');
              toast.setAttribute('role', 'status');
              toast.innerHTML = '<span class="tu-toast__text"></span><a class="tu-toast__link" href="' + (form.dataset.cartUrl || '/cart') + '"></a>';
              document.body.appendChild(toast);
            }
            toast.querySelector('.tu-toast__text').textContent = (data.product_title || data.title || '') + ' ' + (form.dataset.addedLabel || 'wurde in den Warenkorb gelegt.');
            toast.querySelector('.tu-toast__link').textContent = form.dataset.cartLabel || 'Warenkorb ansehen';
            toast.classList.add('is-visible');
            clearTimeout(toast.__timer);
            toast.__timer = setTimeout(() => toast.classList.remove('is-visible'), 3500);
            setTimeout(() => button.classList.remove('is-done'), 1800);
          })
          .catch(() => { form.submit(); })
          .finally(() => { button.classList.remove('is-busy'); button.disabled = false; });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tu-vehicle-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tu-vehicle-bar]').forEach((root) => {
    const form = root.querySelector('[data-tu-vb-form]');
    const selects = [...root.querySelectorAll('.tu-vb__select')];
    const submit = root.querySelector('.tu-vb__submit');
    const saved = root.querySelector('[data-tu-vb-saved]');
    const savedValue = root.querySelector('[data-tu-vb-saved-value]');
    const hint = root.querySelector('[data-tu-vb-hint]');
    const reset = root.querySelector('[data-tu-vb-reset]');
    const KEY = 'tu_vehicle';
    let data = [];
    const placeholders = selects.map((s) => s.options[0].textContent);
    const fill = (select, items, placeholder) => {
      select.innerHTML = '';
      const first = document.createElement('option');
      first.value = '';
      first.textContent = placeholder;
      select.appendChild(first);
      items.forEach((item) => {
        const option = document.createElement('option');
        option.value = String(item[0]);
        option.textContent = item[1];
        select.appendChild(option);
      });
      select.disabled = items.length === 0;
    };
    const brandOf = (id) => data.find((b) => String(b[0]) === String(id));
    const modelOf = (brand, id) => (brand ? brand[2].find((m) => String(m[0]) === String(id)) : null);
    const update = () => {
      const brand = brandOf(selects[0].value);
      const model = modelOf(brand, selects[1].value);
      submit.disabled = !(brand && model && selects[2].value);
    };
    selects[0].addEventListener('change', () => {
      const brand = brandOf(selects[0].value);
      fill(selects[1], brand ? brand[2].map((m) => [m[0], m[1]]) : [], placeholders[1]);
      fill(selects[2], [], placeholders[2]);
      update();
    });
    selects[1].addEventListener('change', () => {
      const brand = brandOf(selects[0].value);
      const model = modelOf(brand, selects[1].value);
      fill(selects[2], model ? model[2] : [], placeholders[2]);
      update();
    });
    selects[2].addEventListener('change', update);
    const readStored = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (error) { return null; } };
    const showSaved = (stored) => {
      const has = !!(stored && stored.label);
      saved.hidden = !has;
      reset.hidden = !has;
      if (hint) hint.hidden = has;
      if (has) savedValue.textContent = stored.label;
    };
    const filterKey = root.dataset.filterKey || 'filter.p.m.custom.fahrzeuge';
    const baseUrl = root.dataset.collectionUrl || root.dataset.allUrl || '/collections/all';
    const buildUrl = (stored) => {
      const params = new URLSearchParams();
      [stored.gidE, stored.gidM, stored.gidB].concat(stored.gidC || []).filter(Boolean).forEach((g) => params.append(filterKey, 'gid://shopify/Metaobject/' + g));
      return baseUrl + '?' + params.toString();
    };
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const brand = brandOf(selects[0].value);
      const model = modelOf(brand, selects[1].value);
      const engine = model ? model[2].find((e) => String(e[0]) === selects[2].value) : null;
      if (!brand || !model || !engine) return;
      const stored = { id: engine[0], brand: brand[0], model: model[0], gidE: engine[2] || '', gidM: model[3] || '', gidB: brand[3] || '', gidC: engine[3] || [], label: brand[1] + ' ' + model[1] + ' · ' + engine[1] };
      try { localStorage.setItem(KEY, JSON.stringify(stored)); } catch (error) { console.warn(error); }
      location.href = buildUrl(stored);
    });
    const filterActive = new URLSearchParams(location.search).getAll(filterKey).length > 0;
    root.classList.toggle('is-active', filterActive);
    root.classList.toggle('is-inactive', !filterActive);
    const statusEl = root.querySelector('[data-tu-vb-status]');
    if (statusEl) statusEl.textContent = filterActive ? 'Fahrzeugfilter aktiv' : 'Kein Fahrzeugfilter – alle Produkte';
    reset.addEventListener('click', () => {
      try { localStorage.removeItem(KEY); } catch (error) { console.warn(error); }
      showSaved(null);
      selects.forEach((s, i) => { if (i > 0) fill(s, [], placeholders[i]); else s.value = ''; });
      update();
      if (filterActive) location.href = baseUrl;
    });
    const stored = readStored();
    showSaved(stored);
    // Variante 1: gespeichertes Fahrzeug auf Kollektionsseiten automatisch anwenden
    if (!filterActive && stored && (stored.gidE || stored.gidM || stored.gidB) && location.pathname.indexOf('/collections/') === 0 && !sessionStorage.getItem('tu_vehicle_skip')) {
      const cur = new URLSearchParams(location.search);
      const target = new URL(buildUrl(stored), location.origin);
      cur.forEach((v, k) => { if (k !== filterKey) target.searchParams.append(k, v); });
      location.replace(target.pathname + '?' + target.searchParams.toString());
      return;
    }
    if (filterActive) {
      const main = document.querySelector('.shopify-section[id$="__main"]');
      const count = main ? main.querySelectorAll('product-card').length : 0;
      const result = root.querySelector('[data-tu-vb-result]');
      const text = root.querySelector('[data-tu-vb-result-text]');
      const link = root.querySelector('[data-tu-vb-result-link]');
      if (result && text) {
        const label = stored && stored.label ? stored.label : 'dein Fahrzeug';
        text.textContent = count === 0
          ? 'Für ' + label + ' sind hier noch keine Produkte hinterlegt.'
          : 'Passende Produkte für ' + label + '.';
        if (link) { link.addEventListener('click', () => { try { localStorage.removeItem(KEY); } catch (error) { console.warn(error); } }); link.hidden = false; link.textContent = 'Fahrzeugfilter aufheben'; link.href = baseUrl; }
        result.hidden = false;
      }
    }
    fetch(root.dataset.vehicleSrc)
      .then((response) => response.json())
      .then((json) => {
        data = Array.isArray(json) ? json : [];
        fill(selects[0], data.map((b) => [b[0], b[1]]), placeholders[0]);
        if (stored && stored.brand) {
          selects[0].value = String(stored.brand);
          const brand = brandOf(stored.brand);
          fill(selects[1], brand ? brand[2].map((m) => [m[0], m[1]]) : [], placeholders[1]);
          if (stored.model) {
            selects[1].value = String(stored.model);
            const model = modelOf(brand, stored.model);
            fill(selects[2], model ? model[2] : [], placeholders[2]);
            selects[2].value = String(stored.id);
          }
          update();
        }
      })
      .catch((error) => console.warn('[tu-vehicle-bar] Fahrzeugdaten konnten nicht geladen werden', error));
  });

  } catch(e) { console.error(e); }
})();
})();
